import { formService } from '@common';
import { ProductGroupAmountValidator } from '../validators';

export const registerValidators = () => {
  formService.registerValidator('productGroupAmount', ProductGroupAmountValidator);
};

export const initForms = () => {
  registerValidators();
};
